module.exports = __webpack_public_path__ + "static/media/spinner.29cfce97.svg";